<template>
	<div class="cont">
		<div class="add-email">
			<p>{{ $t('历史会议') }}</p>
			<div @click="meetingFlag = true">
				<img src="../../assets/img/icons/addEmail.png">
				<span>{{ $t('选择') }}</span>
			</div>
			<!--      <div @click="meetingFlag = true">-->
			<!--        <img src="../../assets/img/icons/addEmail.png">-->
			<!--        <span>{{ $t('通讯录') }}</span>-->
			<!--      </div>-->
		</div>
	</div>


  <el-dialog v-model="meetingFlag" class="newStyleDialog" :title="$t('历史会议')" :width="getWidth()">
<!--    <el-table :data="state.meetingList" highlight-current-row @current-change="handleSelectionChange" height="350px">
     <el-table-column type="selection" width="30" />
      <el-table-column :label="$t('会议主题')" align="center" prop="name" width="160"/>
      <el-table-column :label="$t('时区')" align="center" prop="timezone" width="140">
        <template v-slot="scope">
          <span>{{ getTimezoneTxt(scope.row.timezone) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('会议开始时间')" align="center" prop="startTime" width="110">
        <template v-slot="scope">
          <span>{{ parseTime(convertTimezone(scope.row.timezone,new Date(scope.row.startTime))) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('会议结束时间')" align="center" prop="endTime" width="110">
        <template v-slot="scope">
          <span>{{ parseTime(convertTimezone(scope.row.timezone,new Date(scope.row.endTime))) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('与真号')" align="center" width="100">
        <template v-slot="scope">
         <span>{{ scope.row.virtual.type == 2 ? $t('自有号码：') + scope.row.virtual.virtualRoom  : $t('随机生成') }}</span>
          <span>{{ scope.row.virtual.type == 2 ? scope.row.virtual.virtualRoom  : $t('随机生成') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('方数')" align="center" width="60">
        <template v-slot="scope">
          <span>{{ getVirtualNum(scope.row.virtual,1) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('会议地点')" align="center" width="100">
        <template v-slot="scope">
          <span v-for="item in scope.row.personalRoomList">{{ item.province + "/" + item.area + "/" + item.name + ";" }}<br></span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('与真空间')" align="center" width="100">
        <template v-slot="scope">
          <span v-for="item in scope.row.exclusiveRoomList">{{ item.province + "/" + item.area + "/" + item.name + ";" }}<br></span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('模式')" align="center" width="60">
        <template v-slot="scope">
          <span>{{ getModel(scope.row.model) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('联系人')" align="center" width="100">
        <template v-slot="scope">
          <span v-for="item in scope.row.meetingEmails">{{ item.name }}<br></span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('套餐')" align="center" width="120">
        <template v-slot="scope">
          <span>{{ getVirtualNum(scope.row.virtual,2) }}</span>
        </template>
      </el-table-column>
    </el-table> -->


	<div class="pcCardBox">
		<div class="cardContent-pc" v-for="(item,index) in state.meetingList">
			<div class="item" :class="{ active: historyId == item.id }" @click="historyIndexChange(item,index)"> <!--选中样式active-->
			  <span class="cir"></span>
			</div>
			<h2>{{ item.name }}</h2>
			<!-- <div class="meeting-place">
				<img src="../../assets/img/placeTxtTag.png" alt="" />
				<span v-for="item1 in item.personalRoomList">{{ item1.province + "/" + item1.area + "/" + item1.name + ";" }}</span>
			</div> -->

			<div class="insideInfoCard">
				<div class="top">
					<div class="row1">
						<div class="left">
							<img src="../../assets/img/icons/icon-shiqu.png" class="icon" alt="" />
							<span>
								{{ getTimezoneTxt(item.timezone) }}
							</span>
						</div>
						<div class="meetingId">{{ item.virtual.type == 2 ? item.virtual.virtualRoom  : $t('随机生成') }}</div>
					</div>
					<div class="row2">
						<div class="lable">{{ $t('开始时间：') }}</div>
						<div class="circle-red"></div>
						<span class="time">{{ parseTime(convertTimezone(item.timezone,new Date(item.startTime))) }}</span>
					</div>
					<div class="row2">
						<div class="lable">{{ $t('结束时间：') }}</div>
						<div class="circle-green"></div>
						<span class="time">{{ parseTime(convertTimezone(item.timezone,new Date(item.endTime))) }}</span>
					</div>
					<div class="row2">
						<div class="lable">{{ $t('会议方数：') }}</div>
						<span class="time">{{ getVirtualNum(item.virtual,1) }}</span>
					</div>
					<div class="row2">
						<div class="lable">{{ $t('模式：') }}</div>
						<span class="time">{{ getModel(item.model) }}</span>
					</div>
					<!-- 新增会议地点与参与者⬇ -->
					<div class="row3" v-if="item.meetingPlace">
						<div class="lable">{{ $t('会议地点：') }}</div>
						<div class="location" :class="{heightAuto:item.locationHeight}">{{ item.meetingPlace }}</div>
						<div class="unflod" @click="item.locationHeight=!item.locationHeight">{{item.locationHeight?"收起":"展开"}}</div>
					</div>
          <div class="row3" v-if="item.exclusiveRoomPlace">
            <div class="lable">{{ $t('与真空间：') }}</div>
            <div class="location" :class="{heightAuto:item.exclusiveRoomHeight}">{{ item.exclusiveRoomPlace }}</div>
            <div class="unflod" @click="item.exclusiveRoomHeight=!item.exclusiveRoomHeight">{{item.exclusiveRoomHeight?"收起":"展开"}}</div>
          </div>
					<div class="row3" v-if="item.meetingEmails.length > 0">
						<div class="lable">{{ $t('参与者：') }}</div>
						<div class="attendeeList" :class="{heightAuto:item.meetingEmailsHeight}">
							<div class="attendeeInfo" v-for="item1 in item.meetingEmails">
								<span class="name">{{ item1.name }}</span>
								<span class="emailTxt">{{ item1.email }}</span>
							</div>
<!--							<div class="attendeeInfo">-->
<!--								<span class="name">啊啊啊</span>-->
<!--								<span class="emailTxt">123@qwe.com</span>-->
<!--							</div>-->
<!--							<div class="attendeeInfo">-->
<!--								<span class="name">啊啊啊</span>-->
<!--								<span class="emailTxt">123@qwe.com</span>-->
<!--							</div>-->
<!--							<div class="attendeeInfo">-->
<!--								<span class="name">啊啊啊</span>-->
<!--								<span class="emailTxt">123@qwe.com</span>-->
<!--							</div>-->
						</div>
						<div class="unflod" @click="item.meetingEmailsHeight=!item.meetingEmailsHeight">{{item.meetingEmailsHeight?"收起":"展开"}}</div>
					</div>
					<!-- 新增会议地点与参与者⬆ -->

<!--					<div class="detailsBtn">-->
<!--						<span>查看详情</span>-->
<!--						<img src="../../assets/img/icons/icon-meeting-join-red.png" class="arr" alt="" />-->
<!--					</div>-->
				</div>
				<div class="bottomContent">
<!--					<div class="txt" v-for="item1 in item.exclusiveRoomList">{{ $t('与真空间：') }}{{ item1.province + "/" + item1.area + "/" + item1.name + ";" }}</div>-->
					<div class="txt">{{ $t('套餐：') }}{{ getVirtualNum(item.virtual,2) }}</div>
				</div>
			</div>

		</div>
<!--		<div class="cardContent-pc">-->
<!--			<div class="item"> &lt;!&ndash;选中样式active&ndash;&gt;-->
<!--			  <span class="cir"></span>-->
<!--			</div>-->
<!--			<h2>2023 ArcGIS空间信息技术开发者大会“开源正当时,共赢新未来”</h2>-->
<!--			<div class="meeting-place">-->
<!--				<img src="../../assets/img/placeTxtTag.png" alt="" />-->
<!--				<span>辽宁省/大连市/春田301会议室</span>-->
<!--			</div>-->

<!--			<div class="insideInfoCard">-->
<!--				<div class="top">-->
<!--					<div class="row1">-->
<!--						<div class="left">(GMT+01:00)巴黎,罗马</div>-->
<!--						<div class="meetingId">5416796641</div>-->
<!--					</div>-->
<!--					<div class="row2">-->
<!--						<div class="lable">开始时间</div>-->
<!--						<div class="circle-red"></div>-->
<!--						<span class="time">2024-5-20 10:45:00</span>-->
<!--					</div>-->
<!--					<div class="row2">-->
<!--						<div class="lable">开始时间</div>-->
<!--						<div class="circle-green"></div>-->
<!--						<span class="time">2024-5-20 10:45:00</span>-->
<!--					</div>-->
<!--					<div class="row3">-->
<!--						<div class="lable">方&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数</div>-->
<!--						<span class="time">7</span>-->
<!--					</div>-->
<!--					<div class="row3">-->
<!--						<div class="lable">模&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;式</div>-->
<!--						<span class="time">会议</span>-->
<!--					</div>-->
<!--					<div class="detailsBtn">-->
<!--						<span>查看详情</span>-->
<!--						<img src="../../assets/img/icons/icon-meeting-join-red.png" class="arr" alt="" />-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="bottomContent">-->
<!--					<div class="txt">与真空间：中国-浙江/嘉兴:南湖区建瑞大厦1101号测试会议室(100CNY/小时)</div>-->
<!--					<div class="txt">套餐：A级【上行2.5M】(7方) ·····$49CNY /小时</div>-->
<!--				</div>-->
<!--			</div>-->

<!--		</div>-->
<!--		<div class="cardContent-pc">-->
<!--			<div class="item"> &lt;!&ndash;选中样式active&ndash;&gt;-->
<!--			  <span class="cir"></span>-->
<!--			</div>-->
<!--			<h2>2023 ArcGIS空间信息技术开发者大会“开源正当时,共赢新未来”</h2>-->
<!--			<div class="meeting-place">-->
<!--				<img src="../../assets/img/placeTxtTag.png" alt="" />-->
<!--				<span>辽宁省/大连市/春田301会议室</span>-->
<!--			</div>-->

<!--			<div class="insideInfoCard">-->
<!--				<div class="top">-->
<!--					<div class="row1">-->
<!--						<div class="left">(GMT+01:00)巴黎,罗马</div>-->
<!--						<div class="meetingId">5416796641</div>-->
<!--					</div>-->
<!--					<div class="row2">-->
<!--						<div class="lable">开始时间</div>-->
<!--						<div class="circle-red"></div>-->
<!--						<span class="time">2024-5-20 10:45:00</span>-->
<!--					</div>-->
<!--					<div class="row2">-->
<!--						<div class="lable">开始时间</div>-->
<!--						<div class="circle-green"></div>-->
<!--						<span class="time">2024-5-20 10:45:00</span>-->
<!--					</div>-->
<!--					<div class="row3">-->
<!--						<div class="lable">方&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数</div>-->
<!--						<span class="time">7</span>-->
<!--					</div>-->
<!--					<div class="row3">-->
<!--						<div class="lable">模&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;式</div>-->
<!--						<span class="time">会议</span>-->
<!--					</div>-->
<!--					<div class="detailsBtn">-->
<!--						<span>查看详情</span>-->
<!--						<img src="../../assets/img/icons/icon-meeting-join-red.png" class="arr" alt="" />-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="bottomContent">-->
<!--					<div class="txt">与真空间：中国-浙江/嘉兴:南湖区建瑞大厦1101号测试会议室(100CNY/小时)</div>-->
<!--					<div class="txt">套餐：A级【上行2.5M】(7方) ·····$49CNY /小时</div>-->
<!--				</div>-->
<!--			</div>-->

<!--		</div>-->
	</div>

    <!-- <div class="cardListBox">
      <div class="cardContainer" v-for="(item,index) in state.meetingList" @click="historyIndexChange(item,index) ">
        <div class="nameTagRow">
          <img src="../../assets/img/icons/icon-rectangle.png" class="rectangle" alt="" />
          <h2>{{ item.name }}</h2>
          <div class="item" :class="{ active: historyId == item.id }">
            <span class="cir"></span>
          </div>
        </div>
        <div class="infoSection">
          <div class="row">
            <div class="lable">{{ $t('开始时间：') }}</div>
            <div class="txt">{{ parseTime(convertTimezone(item.timezone,new Date(item.startTime))) }}</div>
          </div>
          <div class="row">
            <div class="lable">{{ $t('与真号：') }}</div>
            <div class="txt">{{ item.virtual.type == 2 ? item.virtual.virtualRoom + "(" + getVirtualNum(item.virtual,1) + $t('方') + ")"  : $t('随机生成') }}</div>
          </div> -->
<!--          <div class="row">-->
<!--            <div class="lable">{{ $t('会议方数：') }}</div>-->
<!--            <div class="txt">{{ getVirtualNum(item.virtual,1) }}</div>-->
<!--          </div>-->
<!--        </div>
      </div> -->
<!--      <div class="cardContainer">-->
<!--        <div class="nameTagRow">-->
<!--          <img src="../../assets/img/icons/icon-rectangle.png" class="rectangle" alt="" />-->
<!--          <h2>2023 ArcGIS空间信息技术开发者大会“开...</h2>-->
<!--          <div class="item"> &lt;!&ndash;选中样式active&ndash;&gt;-->
<!--            <span class="cir"></span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="infoSection">-->
<!--          <div class="row">-->
<!--            <div class="lable">开始时间：</div>-->
<!--            <div class="txt">2023-7-14 15:23:52</div>-->
<!--          </div>-->
<!--          <div class="row">-->
<!--            <div class="lable">与真号：</div>-->
<!--            <div class="txt">668800</div>-->
<!--          </div>-->
<!--          <div class="row">-->
<!--            <div class="lable">会议方数：</div>-->
<!--            <div class="txt">13122131223322331312233223313122332233332233</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    <!-- </div> -->
    <!-- 分页组件 -->
    <el-pagination
        v-model:current-page="meetingPage.pageNo"
        :page-size="meetingPage.pageSize"
        :small="false"
        :disabled="false"
        :background="false"
        layout="total, prev, pager, next"
        :total="state.total"
        @current-change="getMeeting()"
    />

    <div slot="footer" class="btnMarginTop" style="text-align:center">
      <el-button type="primary" @click="submitMeeting">{{ $t('确定') }}</el-button>
      <el-button @click="meetingFlag = false">{{ $t('取消') }}</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
	import {
		getCurrentInstance,
		onMounted,
		reactive,
		ref,
		watch
	} from 'vue';
	import {
		ElMessage
	} from "element-plus";
	import {
		getTimezoneTxt,
		getModel,
		convertTimezone
	} from "@/utils/constants";

	import {
		getHistoryMeeting
	} from "@/api/yuzhen/meeting";
	// 多语言调用
	const {
		appContext: {
			config: {
				globalProperties
			}
		}
	} = getCurrentInstance();

	// 改变传值
	const emit = defineEmits(['selectMeeting'])
  const historyId = ref(-1)
	// 弹窗的是否展示
	const meetingFlag = ref(false)
	//会议地点展开收起
	const locationHeight = ref(false)
	//参与者展开收起
	const attendeeHeight = ref(false)

	const props = defineProps({
		data: {
			type: Array,
			default: []
		},
		virtualNum: Array
	})
	const state = reactive({
		meetingList: [],
		// 总条数
		total: 0,
		selectMeetingId: -1
	})
	// 选择触发
	function handleSelectionChange(value) {
    if(value != null){
      state.selectMeetingId = value.id
    }
	}

	function historyIndexChange(value,index){
	  if(historyId.value == value.id){
      historyId.value = -1
      state.selectMeetingId = -1
    }else {
      state.selectMeetingId = value.id
      historyId.value = value.id
    }
  }

	function submitMeeting() {
    if(state.selectMeetingId == -1){
      meetingFlag.value = false
      return
    }
		emit('selectMeeting', state.selectMeetingId)
		meetingFlag.value = false
	}


	function getWidth() {
		if (window.screen.width > 750) {
			return '60%';
		} else {
			return '90%'
		}
	}

function getVirtualNum(virtual,index){
  if(index == 1){
    return virtual.virtualNum
  }else {
    if(virtual.type === 1){
      for(var i = 0; i < props.virtualNum.length; i++){
        if(props.virtualNum[i].id === parseInt("2" + virtual.packagePriceId)){
          return props.virtualNum[i].txt
        }
      }
    }else {
      // return virtual.virtualNum
    }
  }
}

	// 会议分页查询
	const meetingPage = reactive({
		pageNo: 1,
		pageSize: 10,
	})

	function getMeeting() {
		var query = {
			pageNo: meetingPage.pageNo,
			pageSize: meetingPage.pageSize,
		}
		getHistoryMeeting(query).then(res => {
			state.meetingList = res.data.list
      console.log(res.data.list)
      state.meetingList.forEach(item => {
        if(item.personalRoomList != null){
          item.personalRoomList.forEach(item1 => {
            item.meetingPlace = item1.province + "/" + item1.area + "/" + item1.name + ";"
          })
        }
        if(item.exclusiveRoomList != null){
          item.exclusiveRoomList.forEach(item1 => {
            item.exclusiveRoomPlace = item1.province + "/" + item1.area + "/" + item1.name + ";"
          })
        }
        item.locationHeight = false
        item.exclusiveRoomHeight = false
        item.meetingEmailsHeight = false
      })
			state.total = res.data.total;
		}).catch(err => {
			console.log(err)
		})
	}

	onMounted(() => {
		getMeeting()
	})

	// 日期格式化
	function parseTime(time, pattern) {
		if (arguments.length === 0 || !time) {
			return null
		}
		const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
		let date
		if (typeof time === 'object') {
			date = time
		} else {
			if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
				time = parseInt(time)
			} else if (typeof time === 'string') {
				time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.\d{3}/gm), '');
			}
			if ((typeof time === 'number') && (time.toString().length === 10)) {
				time = time * 1000
			}
			date = new Date(time)
		}
		const formatObj = {
			y: date.getFullYear(),
			m: date.getMonth() + 1,
			d: date.getDate(),
			h: date.getHours(),
			i: date.getMinutes(),
			s: date.getSeconds(),
			a: date.getDay()
		}
		const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
			let value = formatObj[key]
			// Note: getDay() returns 0 on Sunday
			if (key === 'a') {
				return ['日', '一', '二', '三', '四', '五', '六'][value]
			}
			if (result.length > 0 && value < 10) {
				value = '0' + value
			}
			return value || 0
		})
		return time_str
	}
</script>

<style src="./historySelect.css" scoped></style>
